
import draftOrdersIndex from "@/components/page/draft-orders-index.vue";
import { defineComponent } from "vue";

export default defineComponent({
  components: { draftOrdersIndex },
  name: "sales-order-draft-orders",
});
